import { A as ActionCard, d as defineCustomElement$1 } from './action-card.js';

const TtActionCard = ActionCard;
const defineCustomElement = defineCustomElement$1;

export { TtActionCard, defineCustomElement };
